import { render } from "./Disciplinary_Reviews.vue?vue&type=template&id=6de49778"
import script from "./Disciplinary_Reviews.vue?vue&type=script&lang=js"
export * from "./Disciplinary_Reviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__